import { IconButton, Tooltip } from "@hightouch/htui";

import * as analytics from "src/lib/analytics";
import type { Condition } from "src/types/visual";
import { useFilterableOptionsContext } from "src/components/explore/filter-popover/filterable-options-hook";
import { getConditionLabel } from "src/components/explore/filter-popover/utils";
import { GenerateInsightsIcon } from "src/components/llm/components/generate-insights-icon";
import { useFilterInsightsNudge } from "./use-filter-insights-nudge";

const GENERATE_INSIGHTS_PROMPT =
  "Analyze this specific audience filter and explain its impact on audience size. Break down what this filter does in plain English and estimate its size impact as a percentage of the total audience.";

export const GenerateFilterInsightsButton = ({
  condition,
}: {
  condition: Condition;
}) => {
  const nudgeAgent = useFilterInsightsNudge();
  const { relationships, relatedAudiences, journeys, traits } =
    useFilterableOptionsContext();

  if (!nudgeAgent) return null;

  return (
    <Tooltip message="Generate insights" placement="top">
      <IconButton
        aria-label="Generate insights for this filter"
        icon={GenerateInsightsIcon}
        size="sm"
        variant="tertiary"
        onClick={() => {
          analytics.track("Audiences Agent Generate Insights Clicked", {
            conditionType: condition.type,
          });
          nudgeAgent(GENERATE_INSIGHTS_PROMPT, {
            focusedConditions: condition,
            focusedLabel: getConditionLabel(condition, {
              relationships,
              relatedAudiences,
              journeys,
              traits,
            }),
            autoSubmit: true,
          });
        }}
      />
    </Tooltip>
  );
};
